var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gray-200 mr-0 overflow-y-auto w-full maincomponent-area"},[_c('ClientsGrid')],1)}
var staticRenderFns = []

export { render, staticRenderFns }